// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__W7HS+"};